<div class="goback">

  <div class="goback_container">
    <div class="goback_icon">
      <span>
        <img src="{{siteUrlPath}}/{{mediaPath}}/icon-heart-registration.png">
      </span>
    </div>
    <h2>
      {{'registrationStepOne.areYouSureYou' | translate}}<br>
      {{'registrationStepOne.wantToCancleYour' | translate}}<br>
      {{'registrationStepOne.CancleRegistration' | translate}}
    </h2>
    <H3>{{'registrationStepOne.getUptoCashback' | translate}}</H3>
    <button class="site-btn site-btn__secondary site-btn--lg" (click)="continueReg()">{{'registrationStepOne.continueBtn' | translate}}</button>
    <a href="javascript:void(0)" (click)="cancelReg()">{{'registrationStepOne.yesIwantCancel' | translate}}</a>

  </div>
</div>

